export function getFileExtensionFromString(str: string): string {
  return str?.startsWith('.') ? '' : (str.split('.').pop() ?? '');
}
